import { useCallback } from 'react'
import { useWindowWidth, useWindowHeight } from '@react-hook/window-size'
import { isMobile } from 'react-device-detect'

export const useResponsiveSize = () => {
    const windowWidth = useWindowWidth()
    const windowHeight = useWindowHeight()

    const getActualSize = useCallback((pcSize, mobileSize) => {
        if (isMobile || windowWidth <= 540 || windowHeight <= 540 || windowWidth < windowHeight) {
            return Math.round(Math.min(windowWidth, windowHeight) / 540 * mobileSize)
        } else {
            if (windowWidth * 9 >= windowHeight * 16) {
                return Math.round(windowHeight / 1080 * pcSize)
            } else {
                return Math.round((windowWidth / 16 * 9) / 1080 * pcSize)
            }

        }
    }, [windowWidth, windowHeight])

    return getActualSize
}